import { isResultError, } from '../types';
import UrlPattern from 'url-pattern';
export class ContributionsInformationService {
    contributionsAdapter;
    constructor({ contributionsAdapter }) {
        this.contributionsAdapter = contributionsAdapter;
    }
    groupByTeleservice(contributions) {
        const groupedByTS = new Map();
        const teleserviceConfig = new Map();
        for (const contribution of contributions) {
            const cleanTeleserviceHref = contribution.teleservice.href.split('?')[0] ?? '';
            if (!groupedByTS.has(cleanTeleserviceHref)) {
                groupedByTS.set(cleanTeleserviceHref, []);
            }
            teleserviceConfig.set(cleanTeleserviceHref, {
                title: contribution.teleservice.title,
                canCreate: contribution.teleservice.canCreate,
            });
            groupedByTS.get(cleanTeleserviceHref)?.push(contribution);
        }
        return [...groupedByTS.keys()].map((teleserviceHref) => {
            return {
                teleservice: {
                    href: teleserviceHref,
                    title: teleserviceConfig.get(teleserviceHref)?.title ?? '',
                    canCreate: teleserviceConfig.get(teleserviceHref)?.canCreate ?? false,
                },
                contributions: groupedByTS.get(teleserviceHref) ?? [],
            };
        });
    }
    async delete(contributionReference) {
        const result = await this.contributionsAdapter.deleteContributionInformation(contributionReference);
        if (isResultError(result)) {
            throw result.error;
        }
    }
    async listByDemandeFinancement(demandeFinancementReference) {
        const result = await this.contributionsAdapter.listByDemandeFinancement(demandeFinancementReference);
        if (isResultError(result)) {
            throw result.error;
        }
        return result.response;
    }
    /**
     * Create contribution information
     * @param demandeId - Reference of demande financement linked to the contribution information
     * @param teleserviceHref - Id of contribution Information teleservice
     */
    async createContributionInformation(demandeId, teleserviceHref) {
        const result = await this.contributionsAdapter.createContributionInformation(demandeId, teleserviceHref);
        if (isResultError(result)) {
            throw result.error;
        }
        return result.response;
    }
    /**
     * Edit the contribution information with given data
     *
     * @param contributionInformationReference - Reference of contribution information to edit
     * @param data - Data to update
     */
    async editContributionInformation(contributionInformationReference, data) {
        const result = await this.contributionsAdapter.editContributionInformation(contributionInformationReference, data);
        if (isResultError(result)) {
            throw result.error;
        }
        return result.response;
    }
    /**
     * Submit the contribution information with given data
     *
     * @param contributionInformationReference - Reference of contribution information to submit
     * @param data - Data to send for submission
     */
    async submitContributionInformation(contributionInformationReference, data) {
        const result = await this.contributionsAdapter.submitContributionInformation(contributionInformationReference, data);
        if (isResultError(result)) {
            throw result.error;
        }
        return result.response;
    }
    /**
     * Fetch the specified contribution information
     *
     * @param contributionInformationReference - Reference of contribution information to fetch
     */
    async getContributionInformation(contributionInformationReference) {
        const result = await this.contributionsAdapter.getContributionInformation(contributionInformationReference);
        if (isResultError(result)) {
            throw result.error;
        }
        return result.response;
    }
    /**
     * Fetch data needed for depot of contribution information. It includes teleservice, demande-financement, contribution information, pieces to display and mandatory pieces
     *
     * @param contributionInformationReference - Reference of contribution information to fetch data from
     */
    async getContributionInformationDepotContext(contributionInformationReference) {
        const result = await this.contributionsAdapter.getContributionInformationDepotContext(contributionInformationReference);
        if (isResultError(result)) {
            throw result.error;
        }
        return result.response;
    }
    /**
     * Tells if the given id is type information or not
     *
     * @param id - Id to check
     * @returns true if the given id concerns a type-contribution-information
     */
    isTypeInformationId(id) {
        const pattern = new UrlPattern('/referentiel-financement/api/tenants/:tenantId/types-contribution-information/:reference');
        // eslint-disable-next-line unicorn/prefer-regexp-test
        return Boolean(pattern.match(id));
    }
    /**
     * Compute pieces config for a specific contribution information. Includes conditionAffichage and conditionObligatoire
     *
     * @param contributionInformationReference - Reference of contribution information to fetch data from
     * @param currentInformations - Current informations in contribution information form
     */
    async computeContributionInformationPiecesConfig(contributionInformationReference, currentInformations) {
        const result = await this.contributionsAdapter.computeContributionInformationPiecesConfig(contributionInformationReference, currentInformations);
        if (isResultError(result)) {
            throw result.error;
        }
        return result.response;
    }
}
//# sourceMappingURL=contributions-information-service.js.map